import { render, staticRenderFns } from "./TuitionStudentNew.vue?vue&type=template&id=24435ef2&scoped=true&"
import script from "./TuitionStudentNew.vue?vue&type=script&lang=js&"
export * from "./TuitionStudentNew.vue?vue&type=script&lang=js&"
import style0 from "./TuitionStudentNew.vue?vue&type=style&index=0&id=24435ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24435ef2",
  null
  
)

export default component.exports